import { ProcessedCustomLinkItem, SidebarMenuItemProps } from '../../../types';
import { useIsActiveLink } from '../useIsActiveLink';

import { SidebarItem } from './SidebarItem';

export const SidebarWidgetItem = ({
  item,
  showIcon = true,
  isInDoubleDrop = false,
}: SidebarMenuItemProps<ProcessedCustomLinkItem['type']>) => {
  const { name, link, iconName, title } = item;

  const isActiveItem = useIsActiveLink(link);

  return (
    <SidebarItem
      href={link}
      iconName={iconName}
      aqaClass={`aqa_${name}`}
      title={title}
      isActive={isActiveItem}
      external={item.external_system}
      blank={item.blank}
      isCustom={item.blank}
      showIcon={showIcon}
      isInDoubleDrop={isInDoubleDrop}
    />
  );
};
